import React, { useState, useEffect } from "react";
import "./GlobalDateFilter.css";

function GlobalDateFilter({ dateFilter, setDateFilter }) {
  const [selectedMode, setSelectedMode] = useState("today");
  const [customDate, setCustomDate] = useState("");

  const isCustomDateAllowed = (date) => {
    const selected = new Date(date);
    const today = new Date();
    const fourDaysAgo = new Date();
    fourDaysAgo.setDate(today.getDate() - 4);

    selected.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    fourDaysAgo.setHours(0, 0, 0, 0);

    return selected >= fourDaysAgo;
  };

  // 🔥 KEEP COMPONENT IN SYNC WITH PARENT (IMPORTANT)
  useEffect(() => {
    if (dateFilter === "today" || dateFilter === "yesterday") {
      setSelectedMode(dateFilter);
    } else {
      setSelectedMode("custom");
      setCustomDate(dateFilter);
    }
  }, [dateFilter]);

  const handleSelectChange = (e) => {
    const mode = e.target.value;

    if (mode === "custom") {
      setSelectedMode("custom");
      return;
    }

    // TODAY or YESTERDAY
    setSelectedMode(mode);
    setDateFilter(mode);    // 🔥 very important
  };

  const handleCustomDateChange = (e) => {
    const chosen = e.target.value;

    if (!isCustomDateAllowed(chosen)) {
      alert("Only last 4 days are allowed. For older data, use the Reports page.");
      return;
    }

    setCustomDate(chosen);
    setSelectedMode("custom"); // ensure correct mode
    setDateFilter(chosen);     // 🔥 SEND ACTUAL CUSTOM DATE TO BACKEND
  };

  return (
    <div className="gdf-container">
      <div className="gdf-box">
        <span className="gdf-label">Date</span>

        <select
          className="gdf-select"
          value={selectedMode}
          onChange={handleSelectChange}
        >
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="custom">Custom Date</option>
        </select>

        {selectedMode === "custom" && (
          <input
            type="date"
            className="gdf-date-input"
            value={customDate}
            onChange={handleCustomDateChange}
          />
        )}
      </div>
    </div>
  );
}

export default GlobalDateFilter;
